const styles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    width: '640px',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  cardTitle: {
    fontSize: '20px',
    fontWeight: 500,
    marginBottom: '20px',
    textAlign: 'center',
  },
})

export default styles
